export enum GroupMemberRole {
    ALL = -1,
    RESEARCHER = 0,
    GROUP_MANAGER,
    PI,
}
